import { createSelector } from 'reselect'

export const selectRoles = state => state?.roles

export const selectedRolesData = createSelector([selectRoles], roles => {
  const { searchroles, roleInfoData } = roles
  if (searchroles && roleInfoData) {
    return roleInfoData.filter(
      r =>
        r?.name?.toLowerCase().includes(searchroles.toLowerCase()),
    )
  }
  return roleInfoData
})
